import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function OffcanvasUpdateTAC({ show, onHide, selectedRow, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Update Terms-and-Condition')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Terms-and-Condition')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4 d-none">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* TAC Question */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="id">{t('ID')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="id"
                                            defaultValue={selectedRow ? selectedRow.id : ''}
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* TAC Question */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="version">{t('Version')}{' '}(X.X)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="version"
                                            placeholder={t('Enter TAC Version')}
                                            defaultValue={selectedRow ? selectedRow.agb_version : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* TAC Date */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="date">{t('Date')}{' '}(YYYY-MM-DD)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="date"
                                            placeholder={t('Enter TAC Date')}
                                            defaultValue={selectedRow ? selectedRow.agb_date : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* TAC Content */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="content">{t('Content')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            id="content"
                                            placeholder={t('Enter TAC Content')}
                                            defaultValue={selectedRow ? selectedRow.agb_text : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Update TAC')}
                                </>
                            ) : (
                                t('Update TAC')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasUpdateTAC;